// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loading_container__3gd5e {
  width: 100%;
  position: relative;
}
.Loading_container__3gd5e svg {
  width: 50px;
  top: calc(50% - 25px);
  left: calc(50% - 25px);
  position: absolute;
  animation-name: Loading_rotate__VYV1f;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.Loading_container__3gd5e svg circle {
  fill: #3E3E50;
}

@keyframes Loading_rotate__VYV1f {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/reporting/components/graphs/Loading/Loading.module.scss","webpack://./src/components/reporting/styles/colors.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,kBAAA;AAmBF;AAjBE;EACE,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,sBAAA;EACA,mCAAA;EACA,iCAAA;AAmBJ;AAjBI;EACE,aCdE;ADiCR;;AAdA;EACE;IAAM,uBAAA;EAkBN;EAjBA;IAAI,yBAAA;EAoBJ;AACF","sourcesContent":["@use 'components/reporting/styles/colors.scss';\n\n.container{\n  width: 100%;\n  position: relative;\n\n  svg{\n    width: 50px;\n    top: calc(50% - 25px);\n    left: calc(50% - 25px);\n    position: absolute;\n    animation-name: rotate;\n    animation-duration:2s;\n    animation-iteration-count:infinite;\n    animation-timing-function:linear;\n\n    circle{\n      fill: colors.$grey1;\n    }\n  }\n}\n\n@keyframes rotate {\n  from{ transform:rotate(0deg); }\n  to{ transform:rotate(360deg); }\n}","$dark: #121217;\n$light: #FFFFFF;\n\n$grey1: #3E3E50;\n$grey2: #838390;\n$grey3: #C3C3C9;\n$grey4: #E0E0E3;\n$grey5: #F9F9FA;\n\n$blue1: #00007A;\n$blue2: #0000C9;\n$blue3: #4343FF;\n$blue4: #8686FF;\n$blue5: #D8D8FF;\n$blueLogo: #000093;\n\n$orange1: #DA8200;\n$orange2: #FFA92C;\n$orange3: #FFC26B;\n$orange4: #FFE1B7;\n$orange5: #FFF3E3;\n\n$green1: #033E0F;\n$green2: #218214;\n$green3: #58B441;\n$green4: #89D96B;\n$green5: #E1F8CE;\n\n$brick1: #7D1F01;\n$brick2: #B94402;\n$brick3: #E78D3D;\n$brick4: #FBD298;\n$brick5: #FDEBCB;\n\n$red1: #540726;\n$red2: #7C1028;\n$red3: #BD454A;\n$red4: #F4ADA1;\n$red5: #F9D9CF;\n\n\n:export {\n    light: $light;\n    dark: $dark;\n    blue1: $blue1;\n    blue2: $blue2;\n    blue3: $blue3;\n    blue4: $blue4;\n    blue5: $blue5;\n    orange1: $orange1;\n    orange2: $orange2;\n    orange3: $orange3;\n    orange4: $orange4;\n    orange5: $orange5;\n    grey1: $grey1;\n    grey2: $grey2;\n    grey3: $grey3;\n    grey4: $grey4;\n    grey5: $grey5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"light": `#FFFFFF`,
	"dark": `#121217`,
	"blue1": `#00007A`,
	"blue2": `#0000C9`,
	"blue3": `#4343FF`,
	"blue4": `#8686FF`,
	"blue5": `#D8D8FF`,
	"orange1": `#DA8200`,
	"orange2": `#FFA92C`,
	"orange3": `#FFC26B`,
	"orange4": `#FFE1B7`,
	"orange5": `#FFF3E3`,
	"grey1": `#3E3E50`,
	"grey2": `#838390`,
	"grey3": `#C3C3C9`,
	"grey4": `#E0E0E3`,
	"grey5": `#F9F9FA`,
	"container": `Loading_container__3gd5e`,
	"rotate": `Loading_rotate__VYV1f`
};
export default ___CSS_LOADER_EXPORT___;
